import React from 'react';
import { TableHead, TableRow, TableCell, TableSortLabel } from '@mui/material';
import HelpOutlineIcon from '@mui/icons-material/HelpOutline';
import Tooltip from '@mui/material/Tooltip';

interface IssuesTableProps {
  order: 'asc' | 'desc';
  orderBy: string;
  onRequestSort: (event: React.MouseEvent<unknown>, property: string) => void;
  showSimilarCompanyIssues: boolean;
}

const IssuesTable: React.FC<IssuesTableProps> = ({ order, orderBy, onRequestSort, showSimilarCompanyIssues }) => {
  const createSortHandler = (property: string) => (event: React.MouseEvent<unknown>) => {
    onRequestSort(event, property);
  };

  const headCells = [
    { id: 'index', label: 'No', flex: 0.5 },
    { id: 'issue_name', label: '類似課題', flex: 6 },
    {
      id: 'issue_score',
      label: (
        <div style={{ display: 'flex', alignItems: 'center' }}>
          スコア
          <Tooltip title={<div>
            <p>スコアの基準</p>
            <p>0.95以上：非常に高い類似度。ほぼ同じ意味合いの課題。</p>
            <p>0.85～0.95：高い類似度。かなりの共通点がある課題。</p>
            <p>0.70～0.85：中程度の類似度。ある程度似ているが、相違点も含む課題。</p>
            <p>0.50～0.70：低い類似度。異なる内容だが、いくつかの共通点がある課題。</p>
            <p>0.30～0.50：非常に低い類似度。関連性が少なく、わずかな共通点がある課題。</p>
            <p>0.30未満：ほぼ無関係。関連性をほとんど見出せない課題。</p>
          </div>}>
            <HelpOutlineIcon style={{ marginLeft: '8px', cursor: 'pointer', color: 'blue' }} />
          </Tooltip>
        </div>
      ),
      flex: 1.0
    },
    { id: 'companies', label: '似た課題を持つ企業', flex: 5, display: showSimilarCompanyIssues ? 'table-cell' : 'none' },
  ];

  return (
    <TableHead>
      <TableRow sx={{ backgroundColor: 'white', display: 'flex' }}>
        {headCells.map((headCell) => (
          <TableCell key={headCell.id} style={{ flex: headCell.flex, display: headCell.display }}>
            {headCell.id === 'issue_score' ? (
              <TableSortLabel
                active={orderBy === headCell.id}
                direction={orderBy === headCell.id ? order : 'asc'}
                onClick={createSortHandler(headCell.id)}
                style={{ width: '100%' }}
              >
                {headCell.label}
              </TableSortLabel>
            ) : (
              headCell.label
            )}
          </TableCell>
        ))}
      </TableRow>
    </TableHead>
  );
};

export default IssuesTable;